import { takeLatest, put, call } from 'redux-saga/effects';

import { findFornecedorCadastro } from '../service';
import {
  FIND_FORNECEDOR_CADASTRO,
  FIND_FORNECEDOR_CADASTRO_PENDING,
  FIND_FORNECEDOR_CADASTRO_SUCCESS,
  FIND_FORNECEDOR_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaFindFornecedorCadastro(action) {
  yield put({ type: FIND_FORNECEDOR_CADASTRO_PENDING, id: action.id })

  try {

    const registro = yield call(findFornecedorCadastro, action.id);

    yield put({ type: FIND_FORNECEDOR_CADASTRO_SUCCESS, registro: registro })

  } catch (error) {

    yield put({ type: FIND_FORNECEDOR_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchFindFornecedorCadastro() {
  yield takeLatest(FIND_FORNECEDOR_CADASTRO, sagaFindFornecedorCadastro)
}
